import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@mri/environment';

@Pipe({
  name: 'asset',
  standalone: true
})
export class AssetPipe implements PipeTransform {

  transform(url: string, assetKey: string = 'local'): unknown {
    const assetRecord = environment.assets;
    return `${assetRecord[assetKey]}${url}`;
  }

}
